import { MerchantService } from './../services/merchant.service';
import { NavigationService } from '../services/navigation.service';
import { RouteService } from '../services/route.service';
import { Component, OnInit } from '@angular/core';
import {CardholderService} from "../services/cardholder.service";
import {NavItem} from "../navItem";

@Component({
  selector: 'app-navigation-submenu',
  templateUrl: './navigation-submenu.component.html',
  styleUrls: ['./navigation-submenu.component.css']
})
export class NavigationSubmenuComponent implements OnInit {
  navigationItems = <any>[];
  activeRoute = '';
  hasHeader = false;
  merchantType = '';
  chip: boolean;
  vis: string;
  loaded = false;
  closeLoopAcct = false;

  constructor(
    private routeService: RouteService,
    private navigationService: NavigationService,
    private cardholderService: CardholderService,
    public merchantService: MerchantService
  ) {}

  ngOnInit() {
    this.routeService.routeChange.subscribe(routeInfo => {
      const merchant = this.merchantService.getSelectedMerchant();
      if (merchant) {
        this.merchantType = merchant.type
          ? merchant.type
          : merchant.merchantType;
      }
      this.navigationItems = [];
      this.activeRoute = routeInfo.activeRoute;

      const navItem = this.navigationService.getNavItemByRoute(
        this.activeRoute
      );
      if (navItem !== null) {
        this.hasHeader = navItem.hasHeader;
        this.navigationItems = this.navigationService
          .getEntitledNavigationItems()
          .filter(item => {
            let includeIt = false;
            let merchantTypes: string[] = [];

            if (item.merchantTypes) {
              merchantTypes = item.merchantTypes.split(',');
            }

            if (item.parent) {
              includeIt = item.parent === navItem.parent;
            }
            if (includeIt) {
              if (merchantTypes.length) {
                // Don't panic!  We have to set it back to false so
                // we can set it back to true when we find it
                // This is thanks to IE not liking the way we used 'includes'
                includeIt = false;
                merchantTypes.forEach(elem => {
                  if (elem === this.merchantType) {
                    includeIt = true;
                  }
                });
              }
            }
            return includeIt;
          });
          this.loaded = false;
      }
    });
    this.cardholderService.sendChipDetails
      .subscribe(
        (data: boolean) => {
          this.chip = data;
          this.vis = 'visible';
          this.loaded = true;
        }
      );
    this.cardholderService.checkForClosedLoop
      .subscribe(
         (data: boolean) => {
          this.closeLoopAcct = data;
        }
      )  
  }

  keepOLH(item: NavItem) {
    return !(this.chip && item.route === '/cardholderProfiles/');
  }

  //Hides visaForward submenu for closed loop cards.
  hideForCL(item: NavItem) {
    return (item.route === '/cardholderProfiles/visaForward' && this.closeLoopAcct)
  }

  hide() {
    if (this.loaded) {
      this.vis = 'visible';
    }
    else {
      this.vis = 'hidden';
    }
  }
}
